import React, { useEffect } from 'react'
import VismaService from "../services/visma"
export default function Visma(props) {


    useEffect(() => {
        if (props.location.search.indexOf('?token=') >= 0) {
            VismaService.setAuthToken(props.location.search.replace('?token=', ''));
            props.history.push('/accounting');
        } else {

          //  if (window.location.href.indexOf('localhost') >= 0) {
          //      window.location.href = "http://localhost:44300/visma/authenticate";
          //  } else {
                window.location.href = "https://aral.vedebo.net/visma/authenticate";
          //  }
        }
    })

    return (
        <div>

        </div>
    )
}
